import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CloseIcon } from '@/components/UI/Icons/Icons';

export const ModalSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 50px;
`;

export const ModalSheetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalSheetTitle = styled(Typography.Title).attrs({
  $variant: '4',
})``;

export const ModalSheetCloseIcon = styled(CloseIcon).attrs(({ theme }) => ({
  width: 15,
  height: 15,
  fill: theme.palette.secondary.labels,
}))``;
